<template>
  <article>
    <group>
      <cell class="cus_info">
        <img slot="icon" class="cus_img" src="../../stylesheets/images/car.png">
        <p slot="after-title" class="cus_title">{{car.plate_number}}<em class="opacity4" v-if="car.model_desc">－{{car.model_desc}}</em></p>
        <p slot="after-title" class="cus_title">车架号：{{car.vin}}</p>
      </cell>
    </group>
    <group title="车险信息">
      <cell class="ins_info">
        <p slot="after-title" class="ins_title"><span class="label">预存金额</span>{{car.prepaid_insurance_balance | formatePrice}}</p>
        <p slot="after-title" class="ins_title" v-if="insWorkFlowUpgraded"><span class="label">商业险到期日</span>{{car.business_ins_expires_on}}</p>
        <p slot="after-title" class="ins_title" v-if="insWorkFlowUpgraded"><span class="label">交强险到期日</span>{{car.force_ins_expires_on}}</p>
        <p v-else slot="after-title" class="ins_title"><span class="label">保险到期时间</span>{{car.insurance_expires_on}}</p>
        <p slot="after-title" class="ins_title"><span class="label">上次续保公司</span>{{car.last_insurance_company}}</p>
      </cell>
      <divider class="last_ins_title">上次续保险种</divider>
      <cell class="last_ins_info" v-if="car.last_insurance_kinds">
        <p slot="after-title" v-for="(item, index) in car.last_insurance_kinds" :key="index" class="item_info">
          <i class="num">{{index + 1}}</i>{{item | getItemInfo}}
        </p>
      </cell>
      <p class="no_info" v-else>暂无信息</p>
    </group>
  </article>
</template>
<script>
import { Group, Cell, Divider } from '@lx-frontend/cvux'

export default {
  components: {
    Group,
    Cell,
    Divider
  },
  data() {
    return {
      car: {}
    }
  },
  created() {
    let carId = this.$route.query.car_id
    this.car.plate_number = this.$route.query.plate_number
    if (carId) {
      this.$rest.cus.getCarInfo(null, carId).then((res) => {
        if (res.code === 0 && res.data) {
          this.car = res.data.car
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  computed: {
    // 是否启用续保重构流程
    insWorkFlowUpgraded () {
      const {
        customized: {
          store_config: {
            ins_work_flow_upgraded: insWorkFlowUpgraded
          } = {}
        } = {}
      } = this.$store.state

      return insWorkFlowUpgraded
    }
  },
  filters: {
    formatePrice(price) {
      return price ? `￥ ${(price / 100).toFixed(2)}` : ''
    },
    getItemInfo(item) {
      let info = item.name
      let code = item.code
      let pop = item.properties
      if (!pop) {
        return info
      } else {
        if (code === 'mb0005') { // 机动车车上人员责任保险（乘客）
          info += '(' + pop.count + pop.unit + '*'
          if (pop.coverage_unit) {
            info += pop.coverage + pop.coverage_unit
          } else {
            info += pop.coverage + '元'
          }
          info += ')'
        } else if (code === 'ma0006' || code === 'zz0019') {
          info += '(' + pop.glass_type + ')'
        } else {
          if (pop.coverage_unit) {
            info += '(' + pop.coverage + pop.coverage_unit + ')'
          } else if (pop.coverage) {
            info += '(' + pop.coverage + '元)'
          }
        }
        return info
      }
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/cus/info.less";
</style>
